import { getQuery, compareVersions } from '@bbtfe/utils';
function getDefaultV2() {
    const ua = navigator.userAgent.toLowerCase();
    const versionFromQuery = getQuery('babytree-app-version');
    const versionFromUA = ua.slice(ua.indexOf('pregnancy/')).split('/')[1];
    let version = versionFromQuery || versionFromUA || '';
    version = version.replace('-beta', '');
    return version;
}
const Version = {
    greater: function (v1, v2) {
        v2 = v2 || getDefaultV2();
        if (compareVersions(v2, v1) > 0) {
            return true;
        }
        return false;
    },
    less: function (v1, v2) {
        v2 = v2 || getDefaultV2();
        if (compareVersions(v2, v1) < 0) {
            return true;
        }
        return false;
    },
    equal: function (v1, v2) {
        v2 = v2 || getDefaultV2();
        if (compareVersions(v1, v2) == 0) {
            return true;
        }
        return false;
    },
    compare: function (v1, v2) {
        v2 = v2 || getDefaultV2();
        return compareVersions(v1, v2);
    }
};
export default Version;
